import { Component, Input, ViewChild } from '@angular/core';

import { HubspotFormService } from '../../../../Common/Misc/services/hubspot-form.service';
import { MentionInsightUpsellCardComponent } from '../../../../Common/Mentions/components/MentionInsightUpsellCard/mention-insight-upsell-card.component';

import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { ConfigService } from '../../../../Core/Config/services/config.service';
import { PanelComponent } from '@Common/Basic/components/Panel/panel.component';

@Component({
    selector: 'agpr-briefing-insight-upsell-card',
    templateUrl: './briefing-insight-upsell-card.component.html',
    styleUrls: ['./briefing-insight-upsell-card.component.scss'],
    standalone: false
})

export class BriefingInsightUpsellCardComponent extends MentionInsightUpsellCardComponent {
    @Input() id = 'briefingInsightUpsellCard';

    collapsed: boolean = true;

    constructor(
        protected configService: ConfigService,
        protected hubspotFormService: HubspotFormService,
        protected coreDialogService: CoreDialogService
    ) {
        super(configService, hubspotFormService, coreDialogService);
    }

}
